import React from "react";

export default function NoData({
  imageSrc,
  title,
  linkText,
  linkHref,
  iconButton,
  rightIcons = [],
}) {
  return (
    <div className="w-full bg-white rounded-2xl  px-6 py-10 flex justify-center">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10 max-w-5xl w-full">
        {/* Left: Image */}
        <div className="flex-shrink-0 flex justify-center">
          {imageSrc && (
            <img
              src={imageSrc}
              alt="No Data"
              className="w-36 sm:w-48 md:w-56 object-contain"
            />
          )}
        </div>

        {/* Right: Text */}
        <div className="text-center sm:text-left">
          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-2 justify-center sm:justify-start">
            <p className="text-base sm:text-lg font-semibold text-black">
              {title}
            </p>
            {linkText && (
              <a
                href={linkHref || "#"}
                className="text-blue-600 text-sm sm:text-base font-semibold"
              >
                {linkText}
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
